// IELTS Mock 3 — Academic Writing
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK3_WRITING = {
  title: "Academic Writing Practice Test 3",
  tasks: [
    {
      id: "task1",
      mock: 3,
      title: "Task 1: Report (20 min)",
      prompt:
        "The bar chart below shows the percentage of commuters who used five different methods of travelling to work in a city called Riverton in 2000, 2010 and 2020. Summarise the information by selecting and reporting the main features, and make comparisons where relevant.",
      image: "/images/ielts-mock3/writing_task1_commute.svg",
      minWords: 150,
      keywords: ["car", "bus", "train", "bicycle", "cycl", "walk", "commut", "travel", "percent", "proportion", "compar"],
      diagramType: "bar"
    },
    {
      id: "task2",
      mock: 3,
      title: "Task 2: Essay (40 min)",
      prompt:
        "Some people believe that university students should be required to study subjects outside their main field, for example science students studying history or literature. Others think that students should focus only on the subject they have chosen. Discuss both views and give your own opinion. Give reasons for your answer and include any relevant examples from your own knowledge or experience.",
      minWords: 250,
      keywords: ["universit", "student", "subject", "study", "field", "focus", "knowledge", "career", "skill", "opinion"]
    }
  ]
};

export default IELTS_MOCK3_WRITING;
